import React from "react";

import DeletableChip from "@src/sharedComponents/DeletableChip/DeletableChip";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";

import styles from "./TasksFilterChip.module.css";

interface TasksFilterChipProps<T extends string | boolean> {
  label: string;
  values: T[];
  onClear: () => void;
  children: (element: T) => React.ReactNode;
}

const TasksFilterChip = <T extends string | boolean>({
  children,
  label,
  values,
  onClear,
}: TasksFilterChipProps<T>) => {
  return (
    <Tooltip
      classes={{ tooltip: styles.tooltip }}
      tooltipText={
        values.length > 1 && (
          <div className={styles.tooltipContent}>
            {values.map((value, index) => (
              <div className={styles.option} key={index}>
                {children(value)}
              </div>
            ))}
          </div>
        )
      }
      enterDelay={0}
      placement="bottom-start"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
    >
      <div>
        <DeletableChip label={label} onPress={() => null} onClear={onClear} />
      </div>
    </Tooltip>
  );
};

export default TasksFilterChip;
